import React, { useState, useEffect } from 'react';
import { TextInput } from '@mantine/core';

interface PhoneNumberInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
  setValid: (valid: boolean) => void; // Callback to inform parent about validation state
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  placeholder = 'Enter phone number',
  setValid, // Prop to validate the phone number from parent component
}) => {
  const [error, setError] = useState<string>('');

  // Phone number validation function allowing optional '+' and country code
  const validatePhoneNumber = (phoneNumber: string) => {
    const regex = /^[+]?[0-9]{10,15}$/; // Allowing optional '+' at the start and 10-15 digits
    return regex.test(phoneNumber);
  };

  useEffect(() => {
    // Initial validation when the component mounts or value changes
    setValid(validatePhoneNumber(value));
  }, [value, setValid]);

  // Handle input change and validation
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    onChange(event);

    const isValid = validatePhoneNumber(value);
    setValid(isValid); // Notify parent about validation result

    if (isValid) {
      setError(''); // Clear error if valid
    } else {
      setError('Please enter a valid phone number (e.g. +1234567890)');
    }
  };

  return (
    <TextInput
      label={label}
      name={name}
      value={value}
      onChange={handleChange}
      type="tel"
      required={required}
      error={error}
      placeholder={placeholder}
    />
  );
};

export default PhoneNumberInput;
